import PropTypes from 'prop-types';
import React from 'react';
import { Button, Image,ButtonToolbar } from 'react-bootstrap';
import PhotoForm from './PhotoForm';
import { Modal } from 'react-bootstrap';


class Photo extends React.Component {
  constructor(props) {
    super(props);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.state = {
      isEditing: false,
      showConfirm:false,
      modalText: ''
    };
  }
  handleRemove(e) {
    e.preventDefault();
    this.props.removeHotelPhoto(this.props.photo.id);
  }
  handleEdit() {
    this.setState({ isEditing: true });
  }
  handleClose() {
    this.setState({ isEditing: false });
  }
  handleDelete() {
    this.setState({ showConfirm: true,modalText:'Are you sure, you want to delete this Hotel Photo?' });
  }
  handleCloseModal() {
    this.setState({ showConfirm: false });
  }
  handleSubmit(values) {
    const payload = values;
    this.props.editHotelPhoto(this.props.photo.id, payload);
    this.handleClose();
  }

  buildToolbar() {
    return (
      <ul className="hotel-photo-tools">
        <li>
          <Button onClick={this.handleEdit} title="Edit"><i className="fa fa-pencil" /></Button>
        </li>
        <li>
          <Button onClick={this.handleDelete} title="Remove"><i className="fa fa-trash" /></Button>
        </li>
      </ul>
    );
  }
  render() {
    const photo = this.props.photo;
    if (this.state.isEditing) {
      const iv = { name: photo.name };
      return (
        <div className="col-sm-4 col-md-4">
          <div className="thumbnail">
            <Image src={photo.photo} responsive />
            <div className="caption">
              <PhotoForm
                initialValues={iv}
                onSubmit={this.handleSubmit}
                handleClose={this.handleClose}
              />
            </div>
          </div>
        </div>
      );
    }
    const toolbar = this.buildToolbar();
    const name = photo.name ? photo.name : 'Add a Caption';
    let displayName = name;
    if (name.length > 15) {
      displayName = name.slice(0, 14) + "...";
    }
    return (
      <div>
      <div className="col-sm-4 col-md-4">
        <div className="thumbnail">
          <Image src={photo.photo} responsive />
          <div className="caption">
            <h4 onClick={this.handleEdit}>{displayName}</h4>
            {toolbar}
          </div>
        </div>
      </div>
      {this.state.showConfirm && (<Modal show={this.state.showConfirm} onHide={this.handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Delete RoomPhoto</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <p> {this.state.modalText !== '' ? this.state.modalText : 'Are you sure want to delete member?'}</p>

          <ButtonToolbar style={{ float: 'right' }}>
            <Button
              bsStyle="success"
              onClick={this.handleRemove}
            >
                          Confirm
                        </Button>
            <Button
              bsStyle="success"
              onClick={this.handleCloseModal}
            >
                          Cancel
                        </Button>
          </ButtonToolbar>
        </Modal.Body>
        <Modal.Footer style={{ clear: 'both' }} />
      </Modal>
      )}
      </div>
    );
  }
}
Photo.propTypes = {
  photo: PropTypes.object.isRequired,
  removeHotelPhoto: PropTypes.func.isRequired,
  editHotelPhoto: PropTypes.func.isRequired,
};
export default Photo;



// WEBPACK FOOTER //
// src/routes/hotels/components/Photo.js